import { Box, Button, useMediaQuery,Typography } from '@mui/material';
import React from 'react';
import globalStyles from '../../global';
import { getResponsiveSize } from '../../utils/responsive';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { flexRow } from '../../utils/styles';
import { useTranslation } from 'react-i18next';

const CardComponent = ({
  image = 'dohaImage.png',
  buttonUrl = '/events/srilanka',
  regButton = true,
  title ,
  date,
  time,
  location ,
  description ,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:600px)');
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;


  return (
    <Box sx={styles.card}>
      <Box
        sx={[
          styles.container1,
          { backgroundImage: `url(${imageBaseUrl}${image})` },
        ]}
      >
        <Box
          sx={{
            ...styles.box2,
            ...(isMobile && {
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }),
          }}
        >
          <Calendar
            size={isMobile ? getResponsiveSize(14) : getResponsiveSize(24)}
            color={globalStyles.colors.white}
            style={{
              ...styles.icon,
              ...(isMobile && {}),
            }}
          />
          <Box
            sx={[
              styles.text2,
              {
                fontSize: isMobile
                  ? getResponsiveSize(12)
                  : getResponsiveSize(16),
              },
            ]}
          >
            {date}
          </Box>
          <Clock
            size={isMobile ? getResponsiveSize(12) : getResponsiveSize(24)}
            color={globalStyles.colors.white}
            style={{
              ...styles.icon,
              ...(isMobile && {}),
            }}
          />
          <Box
            sx={[
              styles.text2,
              {
                fontSize: isMobile
                  ? getResponsiveSize(12)
                  : getResponsiveSize(16),
              },
            ]}
          >
            {time}
          </Box>
        </Box>
      </Box>
      <Box sx={styles.container2}>
        <Box sx={styles.text1}>{title}</Box>
        <Box
          sx={{
            ...flexRow,
            fontSize: getResponsiveSize(16),
            alignItems: 'center',
            marginTop: getResponsiveSize(1.5),
          }}
        >
          <MapPin
            size={isMobile ? getResponsiveSize(16) : getResponsiveSize(20)}
            color={globalStyles.colors.light_gray}
            style={{ paddingRight: getResponsiveSize(2) }}
          />
          <Box sx={[styles.text3]}>{location}</Box>
        </Box>
        <Box sx={[styles.text3, { marginTop: getResponsiveSize(1.5) }]}>
          {description}
        </Box>
        {/* {regButton ? (
          <Button href={buttonUrl} sx={styles.button}>
            {t('banner.registerToday')}
          </Button>
        ) : null} */}
         {regButton && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, mt: 2  , justifyContent: 'space-between'}}>
  <Button href={buttonUrl} sx={styles.button}>
    {t('banner.registerToday')}
  </Button>

  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {/* Image on the left of text */}
    <Box
      component="img"
      src={`${process.env.REACT_APP_IMAGE_BASE_URL}staticsection_1.svg`} // <-- Replace with your image
      alt="People Joined"
      sx={{ width: 40, height: 40 }}
    />
    <Typography variant="body2" color="text.secondary"  sx={{ fontSize: { xs: "12px", sm: "18px", md: "18px" } }}>
      20+ People Joined
    </Typography>
  </Box>
</Box>

      )}
      </Box>
    </Box>
  );
};

const styles = {
  card: {
    width: '100%',
    maxWidth: getResponsiveSize(556),
    margin: 'auto',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: '20px',
    marginTop: getResponsiveSize(4),
    Padding:3
  },
  container1: {
    height: getResponsiveSize(285),
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: '20px 20px 0px 0px',
  },
  container2: {
    paddingX: getResponsiveSize(3),
    paddingY: getResponsiveSize(1),
    backgroundColor: globalStyles.colors.white,
    borderRadius: '0px 0px 20px 20px',
    border: `1px solid ${globalStyles.colors.base_light}`,
  },
  box2: {
    fontFamily: 'Regular',
    width: '98%',
    fontSize: getResponsiveSize(16),
    color: globalStyles.colors.white,
    height: '98%',
    ...flexRow,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  text1: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    color: globalStyles.colors.light_gray,
    marginTop: getResponsiveSize(1.5),
    fontSize: {
      xs: getResponsiveSize(24 * 0.7),
      sm: getResponsiveSize(24 * 0.8),
      md: getResponsiveSize(22),
    },
  },
  text2: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    marginRight:"24px"
  },
  text3: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    color: globalStyles.colors.light_gray,
    fontSize: {
      xs: getResponsiveSize(18 * 0.7),
      sm: getResponsiveSize(18 * 0.8),
      md: getResponsiveSize(18),
    },
  },
  button: {
    backgroundColor: globalStyles.colors.uclean_green,
    color: globalStyles.colors.white,
    fontFamily: ' "Poppins", serif ',
    fontWeight: 500,
    paddingX: getResponsiveSize(3),
    marginY: getResponsiveSize(3),
    '&:hover': {
      backgroundColor: globalStyles.colors.army_green,
      color: globalStyles.colors.white,
    },
  },
};

export default CardComponent;